exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-793fc3da]{padding:0 30px;width:100%;box-sizing:border-box;text-align:center}img[data-v-793fc3da]{width:100%}.content .tip[data-v-793fc3da]{padding:15px}.btnbox span[data-v-793fc3da]{width:100%;border-radius:5px;color:#fff;display:block;padding:10px 0;margin:10px 0}.btnbox .fb_btn[data-v-793fc3da]{background:#446f9c}.btnbox .em_btn[data-v-793fc3da]{background:#268e87}.btnbox a[data-v-793fc3da]{color:#fff}.ps[data-v-793fc3da]{font-size:12px;line-height:20px}.ps a[data-v-793fc3da]{text-decoration:underline}.link_login[data-v-793fc3da]{font-size:14px;margin-top:15px}.link_login .to_login[data-v-793fc3da]{color:#268e87}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-793fc3da","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/nobody.vue
// module id = 116
// module chunks = 0